import React from 'react'
import AdmExpenseLedger from '../../components/AdminTabs/AdminExpenseLedger/AdmExpenseLedger'

const ExpenseLedger = () => {
  return (
    <div>
      <AdmExpenseLedger/>
    </div>
  )
}

export default ExpenseLedger
